module.exports = __webpack_public_path__ + "static/media/raychem-catalog-fr.6a219c61.pdf";